module.exports = __webpack_public_path__ + "static/media/Durant_gaussian2.746a0af9.png";